// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.agent-chat {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 320px);
  min-height: 420px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius);
  background-color: var(--chat-surface);
  overflow: hidden;
}

/* The shared chat body (transcript → banners → composer), used by the
   team chat dock and the form-assist modal pane. Fills its container. */
.chat-surface {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.chat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border-bottom: 1px solid var(--border-color);
}

/* Pencil + conversation picker/input sit together on the left */
.chat-header-left {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  flex: 1;
}

.chat-header-title {
  font-weight: 600;
}

.chat-new-conversation {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  font-size: 0.85rem;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  background: none;
  color: var(--text-color);
  cursor: pointer;
}

.chat-new-conversation:hover:not(:disabled) {
  border-color: var(--button-primary-bg);
  color: var(--button-primary-bg);
}

.chat-new-conversation:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.chat-connection-banner {
  padding: 6px 12px;
  font-size: 0.85rem;
  text-align: center;
  color: var(--warning-text);
  background-color: var(--warning-bg);
  border-bottom: 1px solid var(--warning-border);
}

.chat-error-banner {
  padding: 8px 12px;
  font-size: 0.9rem;
  color: #b91c1c;
  background-color: #fee2e2;
  border-bottom: 1px solid #fca5a5;
  cursor: pointer;
}

.composer-funds-notice {
  padding: 6px 12px;
  font-size: 0.85rem;
  text-align: center;
  color: var(--warning-text);
  background-color: var(--warning-bg);
  border-top: 1px solid var(--warning-border);
}

.composer-funds-notice a,
.composer-funds-notice-cta {
  color: inherit;
  font-weight: 600;
  text-decoration: underline;
}

/* The "Add funds" CTA is a button (opens a modal) but reads as a plain
   themed link — strip the global button chrome, including the pill shape and
   hover background (\`button:hover\` in App.css outranks a bare class). */
.composer-funds-notice-cta,
.composer-funds-notice-cta:hover {
  background: none;
  border: none;
  border-radius: 0;
  padding: 0;
  margin: 0;
  font: inherit;
  cursor: pointer;
}

/* Out of funds / budget-paused: agents are actually stopped — use the
   stronger Harbor Ledger danger palette. Low funds stays on the softer
   warning palette. Both resolve per theme (light/dark) automatically. */
.composer-funds-notice-no-funds,
.composer-funds-notice-budget {
  color: var(--danger-text);
  background-color: var(--danger-bg);
  border-top: 1px solid var(--danger-text);
}

.chat-message-list {
  flex: 1;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.chat-empty-state {
  margin: auto;
  max-width: 420px;
  text-align: center;
  color: var(--secondary-text-color);
}

.chat-turn {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.chat-user-row {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 8px;
}

/* Messages from other participants align to the left like agent replies */
.chat-turn-other .chat-user-row {
  justify-content: flex-start;
}

.chat-user-bubble {
  max-width: 75%;
  padding: 10px 14px;
  border-radius: var(--radius) var(--radius) 2px var(--radius);
  background-color: var(--accent-tint);
  color: var(--accent-tint-text);
}

/* Another participant's message: neutral grey, left-tailed bubble */
.chat-user-bubble-other {
  border-radius: var(--radius) var(--radius) var(--radius) 2px;
  background-color: var(--card-background);
  color: var(--text-color);
}

.chat-user-text {
  white-space: pre-wrap;
  word-break: break-word;
}

/* Dashed edges distinguish live voice text from the durable transcript that
   replaces it; direction still follows the established chat bubble grammar. */
.voice-provisional-timeline {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.voice-provisional-bubble {
  box-sizing: border-box;
  max-width: min(75%, 40rem);
  padding: 9px 12px;
  border: 1px dashed var(--border-strong);
  overflow-wrap: anywhere;
}

.voice-provisional-bubble-input {
  align-self: flex-end;
  border-color: var(--link-color);
  border-radius: var(--radius) var(--radius) 2px var(--radius);
  background: var(--accent-tint);
  color: var(--accent-tint-text);
}

.voice-provisional-bubble-output {
  align-self: flex-start;
  border-radius: var(--radius) var(--radius) var(--radius) 2px;
  background: var(--surface-raised);
  color: var(--text-color);
}

.voice-provisional-bubble span {
  display: block;
  font-family: var(--font-mono);
  font-size: 0.64rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  opacity: 0.72;
}

.voice-provisional-bubble p {
  margin: 4px 0 0;
  line-height: 1.45;
  white-space: pre-wrap;
}

@media (max-width: 640px) {
  .voice-provisional-bubble {
    max-width: 88%;
  }
}

/* @mention of an agent in a user bubble, linking to its details page.
   Inherits the bubble's text color so it stays legible on both the
   accent-tinted own-message bubble and the neutral other-participant one. */
.chat-mention {
  color: inherit;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.chat-mention:hover {
  opacity: 0.85;
}

.chat-sending-badge {
  font-size: 0.75rem;
  color: var(--secondary-text-color);
  white-space: nowrap;
}

/* Author label above another participant's bubble (multiplayer) */
.chat-user-author {
  align-self: flex-start;
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--secondary-text-color, #6b7280);
  margin-bottom: -4px;
  padding-left: 4px;
}

/* Subtle centered hairline marking a compaction point */
.chat-compacted-divider {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 6px 0;
}

.chat-compacted-divider::before,
.chat-compacted-divider::after {
  content: '';
  flex: 1;
  border-top: 1px solid var(--border-color, #d1d5db);
  opacity: 0.6;
}

.chat-compacted-divider-text {
  font-size: 0.72rem;
  color: var(--secondary-text-color, #6b7280);
  /* Wrap long system notes (e.g. monitor pings) instead of forcing the row
     wider than the chat and causing horizontal scroll. min-width:0 lets this
     flex child shrink below its content width so it can wrap. */
  white-space: normal;
  overflow-wrap: anywhere;
  text-align: center;
  min-width: 0;
}

/* A compaction marker is clickable: it opens the summary modal */
.chat-compacted-divider-button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-family: inherit;
}

.chat-compacted-divider-button:hover {
  color: var(--primary-text-color, #111827);
  text-decoration: underline;
}

/* The compaction summary shown in the divider's modal */
.chat-compaction-summary {
  overflow-y: auto;
  min-height: 0;
  font-size: 0.85rem;
  line-height: 1.5;
  color: var(--primary-text-color, #111827);
}

/* Transient /compact feedback above the composer (noop/failure cases) */
.chat-compact-notice {
  font-size: 0.78rem;
  color: var(--secondary-text-color, #6b7280);
  padding: 4px 12px;
  text-align: center;
  cursor: pointer;
}

/* Thinking region */
.chat-thinking {
  align-self: flex-start;
  max-width: 85%;
}

.chat-thinking-live {
  width: 85%;
  border: 1px dashed var(--border-color);
  border-radius: var(--radius);
  padding: 8px 12px;
  background-color: var(--card-background);
}

.chat-thinking-header {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.85rem;
  color: var(--secondary-text-color);
}

.chat-thinking-icon {
  animation: chat-pulse 1.6s ease-in-out infinite;
}

@keyframes chat-pulse {
  0%,
  100% {
    opacity: 0.4;
  }
  50% {
    opacity: 1;
  }
}

/* Ordered thought text + tool pills, in stream order */
.chat-thinking-segments {
  margin-top: 6px;
  max-height: 140px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.chat-thinking-content {
  font-size: 0.8rem;
  line-height: 1.4;
  word-break: break-word;
  color: var(--secondary-text-color);
}

.chat-thinking-content > :first-child {
  margin-top: 0;
}

.chat-thinking-content > :last-child {
  margin-bottom: 0;
}

.chat-thinking-content p {
  margin: 0.35em 0;
}

.chat-thinking-content h1,
.chat-thinking-content h2,
.chat-thinking-content h3,
.chat-thinking-content h4,
.chat-thinking-content h5,
.chat-thinking-content h6 {
  font-size: 0.9rem;
  margin: 0.65em 0 0.25em;
}

/* "<action_summary>…" — a live turn's one-line status (the
   latest tool call's model-provided summary), shown under the collapsed
   "View thoughts" toggle */
.chat-thinking-status {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  font-size: 0.8rem;
  font-style: italic;
  color: var(--secondary-text-color);
}

.chat-thinking-status-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chat-thinking-toggle {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: none;
  background: none;
  padding: 0;
  font-size: 0.8rem;
  color: var(--link-color);
  cursor: pointer;
}

.chat-thinking-expanded {
  margin-top: 6px;
  max-height: 320px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 6px;
  border-left: 3px solid var(--border-color);
  padding: 6px 12px;
  background-color: var(--card-background);
  border-radius: 0 8px 8px 0;
}

/* A tool call's pill: clickable, opens the tool-call detail modal */
.chat-tool-chip {
  align-self: flex-start;
  font-size: 0.72rem;
  font-family: monospace;
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid var(--border-color);
  color: var(--secondary-text-color);
  background-color: var(--background-color);
  cursor: pointer;
  /* Button reset: chip looks the same as the old non-interactive span */
  appearance: none;
  line-height: 1.4;
}

/* :not(:disabled) bumps specificity above the app-wide \`button:hover\` rule,
   which would otherwise repaint the chip with the primary button color */
.chat-tool-chip:not(:disabled):hover {
  background-color: var(--background-color);
  border-color: var(--link-color);
  color: var(--link-color);
}

.chat-tool-chip-started {
  border-color: var(--button-primary-bg);
  color: var(--button-primary-bg);
}

.chat-tool-chip-failed {
  border-color: #dc2626;
  color: #dc2626;
}

/* A reloaded turn's lazily-fetched tool calls: shown while the request for
   the "View thoughts" panel's tool-call pills is in flight */
.chat-thinking-history-loading {
  font-size: 0.72rem;
  color: var(--secondary-text-color);
}

/* Tool call detail modal (ToolCallModal) */
/* The model's action_summary for the call, shown under the modal title */
.tool-call-modal-summary {
  margin: 0 0 10px;
  font-size: 0.85rem;
  font-style: italic;
  color: var(--secondary-text-color);
}

/* Flags a call whose tool reported failure, so an errored call no longer
   renders identically to a successful one. */
.tool-call-modal-outcome {
  margin: 0 0 10px;
  padding: 6px 10px;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--danger-text);
  border: 1px solid var(--danger-text);
  border-radius: 4px;
}

/* Response-time line ("Took 1.2 s"), under the summary */
.tool-call-modal-duration {
  margin: 0 0 10px;
  font-size: 0.78rem;
  color: var(--secondary-text-color);
}

/* Structured JSON tree (JsonView) inside a tool-call value box */
.json-view {
  font-family: var(--font-mono, monospace);
  font-size: 0.8rem;
  line-height: 1.45;
}

.json-view-row {
  word-break: break-word;
}

.json-view-children {
  padding-left: 18px;
}

.json-view-toggle {
  border: none;
  background: none;
  padding: 0 4px 0 0;
  cursor: pointer;
  font-size: 0.7rem;
  color: var(--secondary-text-color);
}

.json-view-key {
  color: var(--link-color);
}

.json-view-punct,
.json-view-collapsed-note {
  color: var(--secondary-text-color);
}

.json-view-string {
  color: var(--success-text);
  white-space: pre-wrap;
}

.json-view-number {
  color: var(--warning-text);
}

.json-view-boolean {
  color: var(--danger-text);
}

.json-view-null {
  color: var(--secondary-text-color);
  font-style: italic;
}

.tool-call-modal-section-heading {
  margin: 14px 0 4px;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-color);
}

.tool-call-modal-section-heading:first-child {
  margin-top: 0;
}

/* Heading row for an input/output pane: title left, copy control right. The
   copy button sits here rather than inside the scroll pane so it stays put
   while a long value scrolls under it. */
.tool-call-modal-section {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin: 14px 0 4px;
}

.tool-call-modal-section:first-child {
  margin-top: 0;
}

.tool-call-modal-section .tool-call-modal-section-heading {
  margin: 0;
}

/* AsyncButton supplies the icon/label flex row and the disabled treatment;
   this only dresses it down to a quiet secondary control. */
.tool-call-copy {
  padding: 3px 8px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm, 6px);
  background: transparent;
  color: var(--secondary-text-color);
  font-size: 0.72rem;
  cursor: pointer;
}

.tool-call-copy:hover:not(:disabled) {
  background: var(--surface-subtle, rgba(127, 127, 127, 0.08));
  color: var(--text-color);
}

.tool-call-modal-pre {
  margin: 0;
  max-height: 240px;
  overflow: auto;
  padding: 10px;
  white-space: pre-wrap;
  word-break: break-word;
  font-family: monospace;
  font-size: 0.8rem;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm, 6px);
  background-color: var(--card-background);
  color: var(--text-color);
}

/* Agent response */
.chat-agent-response {
  align-self: flex-start;
  max-width: 85%;
  padding: 10px 14px;
  border-radius: var(--radius) var(--radius) var(--radius) 2px;
  background-color: var(--card-background);
  color: var(--text-color);
  word-break: break-word;
}

.chat-agent-response > *:first-child {
  margin-top: 0;
}

.chat-agent-response > *:last-child {
  margin-bottom: 0;
}

.chat-agent-response pre {
  overflow-x: auto;
  padding: 8px;
  border-radius: var(--radius-sm);
  background-color: rgba(0, 0, 0, 0.08);
}

.chat-agent-response code {
  font-size: 0.85em;
}

.chat-agent-response table {
  border-collapse: collapse;
}

.chat-agent-response th,
.chat-agent-response td {
  border: 1px solid var(--border-color);
  padding: 4px 8px;
}

/* Lists, tables, code and quotes in rendered markdown come from the shared
   \`markdown-content\` rules (markdown-content.css), which the chat bubble
   carries alongside .chat-agent-response. */

.chat-agent-response-streaming::after {
  content: '▍';
  animation: chat-pulse 1s ease-in-out infinite;
}

.chat-turn-error {
  align-self: flex-start;
  max-width: 85%;
  padding: 8px 12px;
  border-radius: var(--radius);
  font-size: 0.9rem;
  color: #b91c1c;
  background-color: #fee2e2;
  border: 1px solid #fca5a5;
}

/* A pause is expected/recoverable, not an error: muted amber, not red. */
.chat-turn-paused {
  align-self: flex-start;
  max-width: 85%;
  padding: 8px 12px;
  border-radius: var(--radius);
  font-size: 0.9rem;
  color: #92400e;
  background-color: #fef3c7;
  border: 1px solid #fcd34d;
}

.chat-compacted-divider-text a,
.chat-turn-error a,
.chat-turn-paused a {
  color: inherit;
  font-weight: 600;
  text-decoration: underline;
}

.chat-compacted-divider-text p,
.chat-turn-error p,
.chat-turn-paused p {
  margin: 0;
}

/* Attachments */
.chat-user-attachments {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 6px;
}

.chat-user-attachment-chip {
  font-size: 0.78rem;
  padding: 2px 8px;
  border-radius: 999px;
  background-color: rgba(255, 255, 255, 0.2);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
}

/* Image attachment: small clickable thumbnail (opens full size in a tab) */
.chat-attachment-image {
  display: inline-block;
  line-height: 0;
  border-radius: var(--radius);
  overflow: hidden;
  cursor: pointer;
}
.chat-attachment-image img {
  max-width: 160px;
  max-height: 160px;
  object-fit: cover;
  display: block;
}

/*
 * Images the agent generated are the point of the message, not an aside, so
 * they render large enough to actually judge — unlike the 160px thumbnails
 * used for what a person attached to their own question. Still clickable
 * through to full size, and object-fit is \`contain\` because cropping a
 * generated image hides the composition the person asked for.
 */
.chat-agent-attachments {
  margin-top: 10px;
}
.chat-agent-attachments .chat-attachment-image img {
  max-width: min(420px, 100%);
  max-height: 420px;
  object-fit: contain;
}

/*
 * Generated audio plays in place. Full width of the bubble so the scrubber
 * is usable — a 160px player is a decoration, not a control.
 */
.chat-attachment-audio {
  width: 100%;
  max-width: 420px;
  height: 40px;
  display: block;
}

/* Non-image file: a download chip with the file name */
.chat-attachment-file {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.78rem;
  padding: 4px 10px;
  border-radius: var(--radius);
  background-color: rgba(127, 127, 127, 0.15);
  color: inherit;
  text-decoration: none;
  max-width: 240px;
}
.chat-attachment-file:hover {
  background-color: rgba(127, 127, 127, 0.28);
}
.chat-attachment-file-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Small grey "time ago" beside a sender name / below own messages */
.chat-sent-time {
  font-family: var(--font-mono);
  font-variant-numeric: tabular-nums;
  font-size: 0.7rem;
  font-weight: 400;
  color: var(--secondary-text-color);
}

/* Discreet per-response LLM cost, beside the sent time */
.chat-msg-cost {
  font-size: 0.72rem;
  font-weight: 400;
  color: var(--secondary-text-color, #6b7280);
  cursor: default;
}

/* Muted running conversation total at the end of the chat history */
.chat-conversation-cost {
  align-self: center;
  max-width: 100%;
  font-size: 0.72rem;
  font-weight: 400;
  color: var(--secondary-text-color, #6b7280);
  text-align: center;
  white-space: normal;
  cursor: default;
}

/* Wiki-origin chip: links a highlight-to-chat conversation back to its page */
.chat-wiki-origin-chip {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.72rem;
  padding: 2px 8px;
  margin-right: 8px;
  border: 1px solid var(--border-color);
  border-radius: 999px;
  color: var(--secondary-text-color, #6b7280);
  text-decoration: none;
}

.chat-wiki-origin-chip:hover {
  color: var(--text-color);
  background: color-mix(in srgb, var(--link-color) 8%, transparent);
}
.chat-user-time {
  align-self: flex-end;
  padding-right: 4px;
}

.chat-composer-container {
  border-top: 1px solid var(--border-color);
  background-color: var(--background-color);
}

.chat-attach-error {
  padding: 6px 12px;
  font-size: 0.85rem;
  color: #b91c1c;
  background-color: #fee2e2;
  cursor: pointer;
}

.chat-attachment-previews {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px 12px 0;
}

.chat-attachment-preview {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border: 1px solid var(--border-color);
  border-radius: 999px;
  font-size: 0.8rem;
  color: var(--text-color);
  background-color: var(--card-background);
  max-width: 280px;
}

.chat-attachment-preview-error {
  border-color: #dc2626;
  color: #dc2626;
}

.chat-attachment-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chat-attachment-error-text {
  font-size: 0.72rem;
}

.chat-attachment-spinner {
  animation: chat-spin 1s linear infinite;
}

@keyframes chat-spin {
  to {
    transform: rotate(360deg);
  }
}

.chat-attachment-remove {
  display: flex;
  border: none;
  background: none;
  padding: 2px;
  color: inherit;
  cursor: pointer;
}

.chat-composer-attach {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  /* Global button padding would squeeze the icon inside the fixed-size
     button (same fix as .chat-composer-stop / .chat-dock-action) */
  padding: 0;
  border: 1px solid var(--border-color);
  border-radius: var(--radius);
  background: none;
  color: var(--secondary-text-color);
  cursor: pointer;
}

.chat-composer-attach svg {
  width: 13.5px;
  height: 13.5px;
  flex-shrink: 0;
}

.chat-composer-attach:hover:not(:disabled) {
  color: var(--button-primary-bg);
  border-color: var(--button-primary-bg);
}

/* Composer */
.chat-composer {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  padding: 12px;
}

.chat-composer-input {
  flex: 1;
  resize: none;
  padding: 10px 12px;
  font-size: 0.95rem;
  font-family: inherit;
  line-height: 1.4;
  border: 1px solid var(--input-border);
  border-radius: var(--radius);
  background-color: var(--background-color);
  color: var(--text-color);
}

.chat-composer-input:focus {
  outline: none;
  border-color: var(--button-primary-bg);
}

.chat-composer-send {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 999px;
  background-color: var(--button-primary-bg);
  color: var(--button-primary-text);
  cursor: pointer;
}

.chat-composer-send:hover:not(:disabled) {
  background-color: var(--button-primary-hover);
}

.chat-composer-send:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.chat-composer-voice {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 1px solid var(--button-light-border);
  border-radius: 999px;
  background: var(--button-light-bg);
  color: var(--button-light-text);
  cursor: pointer;
}

.chat-composer-voice:hover:not(:disabled) {
  border-color: var(--button-primary-bg);
  background: var(--button-pill-hover-bg);
}

.chat-composer-voice:focus-visible {
  outline: 2px solid var(--button-primary-bg);
  outline-offset: 2px;
}

/* Pending indicator: shown from send until the first streamed token */
.chat-pending {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 8px 0;
  color: var(--text-secondary, #6b7280);
}

.chat-pending-dots {
  display: inline-flex;
  gap: 4px;
}

.chat-pending-dots span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: currentColor;
  animation: chat-pending-bounce 1.2s infinite ease-in-out;
}

.chat-pending-dots span:nth-child(2) {
  animation-delay: 0.15s;
}

.chat-pending-dots span:nth-child(3) {
  animation-delay: 0.3s;
}

@keyframes chat-pending-bounce {
  0%,
  60%,
  100% {
    opacity: 0.35;
    transform: translateY(0);
  }
  30% {
    opacity: 1;
    transform: translateY(-3px);
  }
}

/* --- Unified team chat --- */

.chat-agent-turn {
  margin-top: 10px;
}

.chat-agent-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--secondary-text-color, #6b7280);
  margin-bottom: 2px;
}

.chat-agent-label-name {
  color: inherit;
  text-decoration: none;
}

a.chat-agent-label-name:hover {
  color: var(--link-color);
  text-decoration: underline;
}

.chat-agent-metadata {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 3px;
  color: var(--secondary-text-color, #6b7280);
}

.chat-agent-label-trigger {
  font-weight: 400;
  opacity: 0.8;
}

.chat-history-picker {
  position: relative;
  min-width: 0;
}

/* Pencil to the left of the conversation picker: rename the chat */
.chat-title-edit-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 20px;
  height: 26px;
  padding: 0;
  border: none;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--secondary-text-color, #6b7280);
  cursor: pointer;
}
/* Inline SVGs collapse to width:0 inside a fixed-size flex button; pin it */
.chat-title-edit-button svg {
  flex: none;
  width: 12px;
  height: 12px;
}

.chat-title-edit-button:hover {
  background: rgba(128, 128, 128, 0.15);
  color: var(--text-color);
}

/* Inline title editor replacing the picker while renaming */
.chat-title-input {
  flex: 1;
  min-width: 0;
  max-width: 240px;
  padding: 4px 8px;
  border: 1px solid var(--primary-color, #4a90d9);
  border-radius: var(--radius-sm);
  background: var(--background-color);
  color: var(--text-color);
  font-weight: 600;
  font-size: 0.9rem;
}

.chat-history-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 220px;
  padding: 4px 8px;
  border: none;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--text-color);
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
}

.chat-history-button:hover {
  background: rgba(128, 128, 128, 0.15);
}

.chat-history-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chat-history-options {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 10;
  min-width: 240px;
  max-width: 320px;
  max-height: 280px;
  overflow-y: auto;
  padding: 4px;
  border: 1px solid var(--border-color, #d1d5db);
  border-radius: var(--radius);
  background: var(--background-color, #fff);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.chat-history-option {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 6px 10px;
  border: none;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--text-color);
  font-size: 0.85rem;
  text-align: left;
  cursor: pointer;
}

.chat-history-option-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1px;
}

.chat-history-option-title {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chat-history-option-time {
  font-size: 0.7rem;
  color: var(--secondary-text-color, #6b7280);
}

/* Per-conversation unread mention count in the history dropdown */
.chat-history-unread {
  flex: none;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: var(--danger-bg, #e5484d);
  color: #fff;
  font-size: 0.68rem;
  font-weight: 700;
  line-height: 1;
}

.chat-history-option:hover {
  background: rgba(128, 128, 128, 0.12);
}

.chat-history-option-active {
  color: var(--primary-color, #4a90d9);
  font-weight: 600;
}

.chat-history-empty {
  display: block;
  padding: 8px 10px;
  font-size: 0.85rem;
  color: var(--secondary-text-color, #6b7280);
}

.chat-composer {
  position: relative;
}

.chat-mention-popup {
  position: absolute;
  bottom: calc(100% + 6px);
  left: 48px;
  z-index: 20;
  min-width: 180px;
  max-height: 200px;
  overflow-y: auto;
  padding: 4px;
  border: 1px solid var(--border-color, #d1d5db);
  border-radius: var(--radius);
  background: var(--background-color, #fff);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.18);
}

.chat-mention-option {
  display: block;
  width: 100%;
  padding: 6px 10px;
  border: none;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--text-color);
  font-size: 0.875rem;
  text-align: left;
  cursor: pointer;
}

.chat-mention-option:hover {
  background: rgba(128, 128, 128, 0.12);
}

.chat-mention-option-active {
  background: rgba(74, 144, 217, 0.15);
  color: var(--primary-color, #4a90d9);
  font-weight: 600;
}

/* Agents that can be mentioned only after being added (e.g. team agents
   not on the project) — selectable, but visibly secondary */
.chat-mention-option-unavailable {
  color: var(--secondary-text-color);
  opacity: 0.65;
}

.chat-approval-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin: 0 12px 8px;
  padding: 8px 12px;
  border: 1px solid rgba(224, 130, 6, 0.4);
  border-radius: var(--radius);
  background: rgba(224, 130, 6, 0.1);
  color: var(--text-color);
  font-size: 0.85rem;
}

.chat-approve-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border: none;
  border-radius: var(--radius-sm);
  background: var(--button-primary-bg, #4a90d9);
  color: var(--button-primary-text, #fff);
  font-size: 0.85rem;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
}

.chat-composer-stop {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: none;
  border-radius: var(--radius);
  background-color: #e0245e;
  color: #fff;
  cursor: pointer;
  flex-shrink: 0;
}

.chat-composer-stop:hover {
  background-color: #c01e50;
}

.chat-composer-stop svg {
  flex-shrink: 0;
}

/* ── Inline interactive prompts (seek_feedback / request_capability) ── */
.chat-interaction {
  margin: 8px 0 2px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.chat-interaction-options {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.chat-interaction-option {
  border: 1px solid var(--primary-color, #2563eb);
  color: var(--primary-color, #2563eb);
  background: transparent;
  border-radius: 16px;
  padding: 5px 12px;
  font-size: 0.85rem;
  cursor: pointer;
}
.chat-interaction-option:hover:not(:disabled) {
  background: var(--primary-color, #2563eb);
  color: #fff;
}
.chat-interaction-option:disabled {
  opacity: 0.5;
  cursor: default;
}
.chat-interaction-other {
  display: flex;
  gap: 6px;
}
/* App.css's global \`form button { width: 100% }\` would crush the input */
.chat-interaction-other button {
  width: auto;
  flex: 0 0 auto;
}
.chat-interaction-other input {
  flex: 1;
  min-width: 0;
  padding: 6px 10px;
  border: 1px solid var(--input-border, #d1d5db);
  border-radius: var(--radius);
  background: var(--background-color, #fff);
  color: var(--text-color, #111);
}
.chat-interaction-other button,
.chat-interaction-grant,
.chat-interaction-decline {
  border: none;
  border-radius: var(--radius);
  padding: 6px 12px;
  font-size: 0.85rem;
  cursor: pointer;
}
.chat-interaction-other button,
.chat-interaction-grant {
  background: var(--button-primary-bg, #2563eb);
  color: var(--button-primary-text, #fff);
}
.chat-interaction-decline {
  background: var(--surface-hover-bg, #e5e7eb);
  color: var(--text-color, #111);
}
.chat-interaction-other button:disabled,
.chat-interaction-grant:disabled,
.chat-interaction-decline:disabled {
  opacity: 0.5;
  cursor: default;
}
.chat-interaction-permission {
  border: 1px solid var(--warning-border, #f0c36d);
  background: var(--warning-bg, #fdf6e3);
  color: var(--warning-text, #7a5b00);
  border-radius: 10px;
  padding: 10px 12px;
}
/* A decided request is no longer a call to action: drop the warning tint
   and blend into the page, leaving a colored outcome line */
.chat-interaction-permission-resolved {
  border-color: var(--border-color, #e5e7eb);
  background: var(--card-background, #f5f5f5);
  color: var(--text-color, #111);
}
.chat-interaction-resolution {
  font-size: 0.85rem;
  font-weight: 600;
  margin-top: 6px;
}
.chat-interaction-resolution.approved {
  color: var(--success-text, #15803d);
}
.chat-interaction-resolution.declined {
  color: var(--danger-text, #b91c1c);
}
.chat-interaction-permission-head {
  font-size: 0.9rem;
}
/* Card next actions are a record of what the agent decided to do next, not a
   request. Deliberately neutral: no warning tint, no buttons, nothing that
   reads as waiting on a person. */
.chat-interaction-next-action {
  border: 1px solid var(--border-color, #e5e7eb);
  background: var(--card-background, #f5f5f5);
  color: var(--text-color, #111);
  border-radius: 10px;
  padding: 8px 12px;
  gap: 2px;
}
.chat-interaction-next-action-head {
  font-size: 0.8rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  opacity: 0.7;
}
.chat-interaction-next-action-body {
  font-size: 0.85rem;
}
.chat-interaction-permission-desc {
  font-size: 0.8rem;
  opacity: 0.85;
  margin-top: 4px;
}
.chat-interaction-actions {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}
/* Background monitor card: pending spinner + cancel, terminal badge */
.chat-interaction-monitor {
  display: flex;
  flex-direction: column;
  gap: 8px;
  border: 1px solid var(--border-color, #e5e7eb);
  background: var(--card-background, #f5f5f5);
  color: var(--text-color, #111);
  border-radius: 10px;
  padding: 8px 12px;
  font-size: 0.85rem;
}
/* Pending card is a grid so Cancel sits top-right beside the status line on
   wide screens, and drops below the progress + centers on phones. Base stays
   flex (above) for the terminal badge variant. */
.chat-interaction-monitor-pending {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-areas:
    'status cancel'
    'progress progress'
    'error error';
  align-items: center;
  gap: 8px 12px;
}
.chat-interaction-monitor-pending .chat-interaction-monitor-row {
  grid-area: status;
}
.chat-interaction-monitor-pending .chat-interaction-monitor-progress {
  grid-area: progress;
}
.chat-interaction-monitor-pending .chat-interaction-monitor-cancel {
  grid-area: cancel;
  justify-self: end;
}
.chat-interaction-monitor-pending .chat-interaction-error {
  grid-area: error;
}
@media (max-width: 768px) {
  .chat-interaction-monitor-pending {
    grid-template-columns: 1fr;
    grid-template-areas:
      'status'
      'progress'
      'cancel'
      'error';
  }
  .chat-interaction-monitor-pending .chat-interaction-monitor-cancel {
    justify-self: center;
  }
}
.chat-interaction-monitor-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
/* Script-reported progress (MONITOR_STATUS / MONITOR_PROGRESS markers).
   The bar flexes and the label wraps below it on narrow (mobile) widths
   instead of squeezing into a skinny column beside the bar. */
.chat-interaction-monitor-progress {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 10px;
}
.chat-interaction-monitor-progressbar {
  flex: 1 1 140px;
  max-width: 260px;
  height: 8px;
  border-radius: 4px;
  background: var(--border-color, #e5e7eb);
  overflow: hidden;
}
.chat-interaction-monitor-progressbar-fill {
  height: 100%;
  border-radius: 4px;
  background: var(--accent-color, #2563eb);
  transition: width 0.6s ease;
}
.chat-interaction-monitor-progress-label {
  font-size: 0.8rem;
  opacity: 0.85;
  overflow-wrap: anywhere;
}
.chat-interaction-monitor-spinner {
  width: 14px;
  height: 14px;
  flex: 0 0 auto;
  border: 2px solid var(--border-color, #e5e7eb);
  border-top-color: var(--accent-color, #2563eb);
  border-radius: 50%;
  animation: chat-monitor-spin 0.9s linear infinite;
}
@keyframes chat-monitor-spin {
  to {
    transform: rotate(360deg);
  }
}
.chat-interaction-monitor-text {
  /* Shrinkable with a modest basis so the spinner keeps the text company on
     the first line even at phone widths (basis auto would push the whole
     text block onto its own row, stranding the spinner). */
  flex: 1 1 200px;
  min-width: 0;
}
.chat-interaction-monitor-cancel {
  flex: 0 0 auto;
}
.chat-interaction-monitor-badge {
  font-weight: 600;
}
.chat-interaction-monitor-done .chat-interaction-monitor-badge {
  color: var(--success-text, #15803d);
}
.chat-interaction-monitor-timeout .chat-interaction-monitor-badge,
.chat-interaction-monitor-error .chat-interaction-monitor-badge {
  color: var(--danger-text, #b91c1c);
}
.chat-interaction-monitor-canceled .chat-interaction-monitor-badge {
  color: var(--text-muted, #6b7280);
}

/* Agent-authored "how to obtain this credential" walkthrough (markdown) */
.chat-interaction-instructions {
  font-size: 0.82rem;
  line-height: 1.5;
  background: var(--background-color, #fff);
  border: 1px solid var(--border-color, #e5e7eb);
  border-radius: var(--radius);
  padding: 10px 12px;
  margin: 8px 0 12px;
  max-height: 260px;
  overflow-y: auto;
}
.chat-interaction-instructions p,
.chat-interaction-instructions ol,
.chat-interaction-instructions ul {
  margin: 0 0 6px;
  padding-left: 18px;
}
.chat-interaction-instructions p {
  padding-left: 0;
}
.chat-interaction-instructions :last-child {
  margin-bottom: 0;
}
.chat-interaction-error {
  color: var(--warning-text, #7a5b00);
  font-size: 0.8rem;
}

/* Grant params modal */
.interaction-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.interaction-modal {
  background: var(--card-background, #fff);
  color: var(--text-color, #111);
  border-radius: var(--radius);
  padding: 20px;
  width: min(440px, 92vw);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}
.interaction-modal h3 {
  margin: 0 0 6px;
}
.interaction-modal-sub {
  font-size: 0.82rem;
  color: var(--secondary-text-color, #6b7280);
  margin: 0 0 14px;
}
.interaction-modal-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 12px;
  font-size: 0.82rem;
}
.interaction-modal-field input {
  padding: 8px 10px;
  border: 1px solid var(--input-border, #d1d5db);
  border-radius: var(--radius);
  background: var(--background-color, #fff);
  color: var(--text-color, #111);
}
.interaction-modal-error {
  color: var(--warning-text, #b45309);
  font-size: 0.8rem;
  margin-bottom: 10px;
}
.interaction-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.interaction-modal-actions button {
  border: none;
  border-radius: var(--radius);
  padding: 8px 14px;
  cursor: pointer;
  background: var(--surface-hover-bg, #e5e7eb);
  color: var(--text-color, #111);
}
.interaction-modal-actions .interaction-modal-save {
  background: var(--button-primary-bg, #2563eb);
  color: var(--button-primary-text, #fff);
}
.chat-interaction-decision-note {
  display: grid;
  gap: 5px;
  margin: 10px 0;
  font-size: 0.78rem;
  color: var(--text-muted, #6b7280);
}
.chat-interaction-decision-note textarea,
.interaction-modal-field textarea {
  min-height: 58px;
  resize: vertical;
  border: 1px solid var(--border-color, #ccc);
  border-radius: 7px;
  padding: 8px;
  color: inherit;
  background: var(--input-bg, transparent);
}
.chat-approval-inline {
  margin: 12px 0;
}
/* The work-stream pointer. It used to float in the gap between the composer
   and the transcript, which read as chrome bolted onto the input; it is a
   standing fact about the conversation, so it now sits at the END of the
   transcript and scrolls with it. Same bare treatment as .chat-notice above —
   no border, no fill, nobody said it — but a full-width row rather than
   centered, because the run's status is a second column, not a trailing
   clause. */
.chat-work-stream-link {
  align-items: center;
  align-self: stretch;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  margin-top: -6px;
}

.chat-work-stream-link a {
  color: var(--link-color, #2563eb);
  font-size: 0.82rem;
}

.chat-work-stream-link span {
  color: var(--secondary-text-color);
  flex: none;
  font-size: 0.72rem;
  text-transform: capitalize;
}

/* Deferred wait card. Same anatomy as the monitor card above — pending
   spinner with a Cancel, terminal badge — because they are the same thing to
   a reader: the agent is asleep and will come back. */
.chat-interaction-wait {
  display: flex;
  flex-direction: column;
  gap: 8px;
  border: 1px solid var(--border-color, #e5e7eb);
  background: var(--card-background, #f5f5f5);
  color: var(--text-color, #111);
  border-radius: 10px;
  padding: 8px 12px;
  font-size: 0.85rem;
}
.chat-interaction-wait-pending {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-areas:
    'status cancel'
    'progress progress'
    'error error';
  align-items: center;
  gap: 8px 12px;
}
.chat-interaction-wait-pending .chat-interaction-wait-row {
  grid-area: status;
}
.chat-interaction-wait-pending .chat-interaction-wait-progress {
  grid-area: progress;
}
.chat-interaction-wait-pending .chat-interaction-wait-cancel {
  grid-area: cancel;
  justify-self: end;
  width: auto;
  margin-top: 0;
}
.chat-interaction-wait-pending .chat-interaction-error {
  grid-area: error;
}
.chat-interaction-wait-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.chat-interaction-wait-spinner {
  width: 12px;
  height: 12px;
  flex: 0 0 auto;
  border: 2px solid var(--border-color, #d1d5db);
  border-top-color: var(--primary-color, #2563eb);
  border-radius: 50%;
  animation: chat-monitor-spin 0.9s linear infinite;
}
.chat-interaction-wait-progress {
  color: var(--secondary-text-color, #6b7280);
  font-size: 0.8rem;
}
.chat-interaction-wait-badge {
  font-weight: 600;
}
.chat-interaction-wait-reason {
  color: var(--secondary-text-color, #6b7280);
}
/* Max time reached is not an error state: nothing broke, the clock ran out,
   and the agent has already been woken to decide what to do. */
.chat-interaction-wait-failed .chat-interaction-wait-badge {
  color: var(--danger-color, #b91c1c);
}
@media (max-width: 640px) {
  .chat-interaction-wait-pending {
    grid-template-columns: 1fr;
    grid-template-areas:
      'status'
      'progress'
      'cancel'
      'error';
  }
  .chat-interaction-wait-pending .chat-interaction-wait-cancel {
    justify-self: stretch;
  }
}

/* Form-assist hand-off notice: the form was submitted and the record now
   exists. Nobody's utterance, so it gets no bubble chrome at all — a bordered,
   tinted pill read as just another message from someone. Bare text on the
   transcript background is the whole treatment. */
.chat-notice {
  align-self: center;
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 92%;
  margin: 6px 0;
  color: var(--secondary-text-color);
  font-size: 0.78rem;
  text-align: left;
  overflow-wrap: anywhere;
}

.chat-voice-lifecycle {
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  text-align: center;
}

.chat-voice-lifecycle-cost {
  font-family: var(--font-mono);
  font-size: 0.7rem;
  font-variant-numeric: tabular-nums;
}

.chat-artifact-notice {
  align-items: stretch;
  flex-direction: column;
  width: min(720px, 92%);
}

.chat-artifact-notice video {
  display: block;
  width: 100%;
  max-height: 420px;
  border-radius: var(--radius-sm);
  background: #000;
}
`, "",{"version":3,"sources":["webpack://./src/agent-chat.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,iBAAiB;EACjB,qCAAqC;EACrC,4BAA4B;EAC5B,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;wEACwE;AACxE;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;wEAEwE;AACxE;;EAEE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,eAAe;AACjB;;AAEA;;wEAEwE;AACxE;;EAEE,yBAAyB;EACzB,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,QAAQ;AACV;;AAEA,0EAA0E;AAC1E;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,4DAA4D;EAC5D,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA,oEAAoE;AACpE;EACE,4DAA4D;EAC5D,wCAAwC;EACxC,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;8EAC8E;AAC9E;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,iBAAiB;EACjB,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,+BAA+B;EAC/B,4DAA4D;EAC5D,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,4DAA4D;EAC5D,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;;4EAE4E;AAC5E;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA,kEAAkE;AAClE;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,OAAO;EACP,kDAAkD;EAClD,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C;;gEAE8D;EAC9D,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;;AAEA,iEAAiE;AACjE;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA,wDAAwD;AACxD;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,wEAAwE;AACxE;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,sCAAsC;EACtC,4BAA4B;EAC5B,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE;;IAEE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;;AAEA,uDAAuD;AACvD;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;EAME,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;2BAE2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,0CAA0C;EAC1C,iBAAiB;EACjB,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA,oEAAoE;AACpE;EACE,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;EACrC,kCAAkC;EAClC,yCAAyC;EACzC,eAAe;EACf,sEAAsE;EACtE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;yEACyE;AACzE;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;6DAC6D;AAC7D;EACE,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,2CAA2C;AAC3C,yEAAyE;AACzE;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;6CAC6C;AAC7C;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA,yDAAyD;AACzD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,iEAAiE;AACjE;EACE,wCAAwC;EACxC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;;yCAEyC;AACzC;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;4DAC4D;AAC5D;EACE,gBAAgB;EAChB,qCAAqC;EACrC,oCAAoC;EACpC,uBAAuB;EACvB,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,4DAA4D;EAC5D,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;EACjB,qCAAqC;EACrC,oCAAoC;EACpC,wCAAwC;EACxC,wBAAwB;AAC1B;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,4DAA4D;EAC5D,wCAAwC;EACxC,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;;4CAE4C;;AAE5C;EACE,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,4BAA4B;EAC5B,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,yEAAyE;AACzE;EACE,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,4BAA4B;EAC5B,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;EAGE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;;EAGE,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,2EAA2E;AAC3E;EACE,qBAAqB;EACrB,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;;;;EAME;AACF;EACE,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;;EAGE;AACF;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA,uDAAuD;AACvD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;EAC5B,2CAA2C;EAC3C,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,oEAAoE;AACpE;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA,yDAAyD;AACzD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,eAAe;AACjB;;AAEA,oEAAoE;AACpE;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,8EAA8E;AAC9E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;EACrC,oBAAoB;EACpB,2CAA2C;EAC3C,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,iEAAiE;AACnE;AACA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qCAAqC;EACrC,oBAAoB;EACpB,iBAAiB;EACjB,wBAAwB;EACxB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ;mEACiE;EACjE,UAAU;EACV,qCAAqC;EACrC,4BAA4B;EAC5B,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA,aAAa;AACb;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,qCAAqC;EACrC,4BAA4B;EAC5B,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,0CAA0C;EAC1C,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,4CAA4C;EAC5C,oBAAoB;EACpB,kCAAkC;EAClC,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,wDAAwD;AAC1D;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;;;IAGE,aAAa;IACb,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA,8BAA8B;;AAE9B;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA,mEAAmE;AACnE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,+BAA+B;EAC/B,uBAAuB;EACvB,2CAA2C;EAC3C,eAAe;AACjB;AACA,4EAA4E;AAC5E;EACE,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA,4DAA4D;AAC5D;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;EAC/C,+BAA+B;EAC/B,mCAAmC;EACnC,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,8CAA8C;EAC9C,4BAA4B;EAC5B,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,+BAA+B;EAC/B,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA,kEAAkE;AAClE;EACE,UAAU;EACV,eAAe;EACf,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qCAAqC;EACrC,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,8CAA8C;EAC9C,4BAA4B;EAC5B,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,+BAA+B;EAC/B,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;4DAC4D;AAC5D;EACE,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,wCAAwC;EACxC,4BAA4B;EAC5B,kCAAkC;EAClC,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,+BAA+B;EAC/B,6CAA6C;EAC7C,uCAAuC;EACvC,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,4BAA4B;EAC5B,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA,0EAA0E;AAC1E;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,+CAA+C;EAC/C,oCAAoC;EACpC,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,yCAAyC;EACzC,WAAW;AACb;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA,yEAAyE;AACzE;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,OAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,8CAA8C;EAC9C,4BAA4B;EAC5B,yCAAyC;EACzC,8BAA8B;AAChC;AACA;;;EAGE,YAAY;EACZ,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA;;EAEE,6CAA6C;EAC7C,uCAAuC;AACzC;AACA;EACE,4CAA4C;EAC5C,8BAA8B;AAChC;AACA;;;EAGE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,gDAAgD;EAChD,sCAAsC;EACtC,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;AACpB;AACA;4DAC4D;AAC5D;EACE,0CAA0C;EAC1C,2CAA2C;EAC3C,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iBAAiB;AACnB;AACA;;kCAEkC;AAClC;EACE,8CAA8C;EAC9C,2CAA2C;EAC3C,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA,sEAAsE;AACtE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,8CAA8C;EAC9C,2CAA2C;EAC3C,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;;iDAEiD;AACjD;EACE,aAAa;EACb,+BAA+B;EAC/B;;;iBAGe;EACf,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,0BAA0B;IAC1B;;;;aAIS;EACX;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;AACA;;8DAE8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,8CAA8C;EAC9C,8CAA8C;EAC9C,kBAAkB;EAClB,iDAAiD;AACnD;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;;2DAEyD;EACzD,eAAe;EACf,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mCAAmC;AACrC;AACA;;EAEE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;;AAEA,0EAA0E;AAC1E;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,8CAA8C;EAC9C,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;EAGE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,wCAAwC;EACxC,8BAA8B;EAC9B,4BAA4B;EAC5B,aAAa;EACb,uBAAuB;EACvB,0CAA0C;AAC5C;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,8CAA8C;EAC9C,4BAA4B;EAC5B,yCAAyC;EACzC,8BAA8B;AAChC;AACA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;AACA;EACE,YAAY;EACZ,4BAA4B;EAC5B,iBAAiB;EACjB,eAAe;EACf,4CAA4C;EAC5C,8BAA8B;AAChC;AACA;EACE,6CAA6C;EAC7C,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,iCAAiC;AACnC;AACA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,wCAAwC;AAC1C;AACA;EACE,cAAc;AAChB;AACA;;;;;;YAMY;AACZ;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,UAAU;EACV,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;;sDAEsD;AACtD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,8CAA8C;EAC9C,2CAA2C;EAC3C,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B;;;iBAGe;EACf,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,8CAA8C;EAC9C,+CAA+C;EAC/C,kBAAkB;EAClB,iDAAiD;AACnD;AACA;EACE,2CAA2C;EAC3C,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,2CAA2C;AAC7C;AACA;+DAC+D;AAC/D;EACE,mCAAmC;AACrC;AACA;EACE;IACE,0BAA0B;IAC1B;;;;aAIS;EACX;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;;;kDAGkD;AAClD;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,aAAa;EACb,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB","sourcesContent":[".agent-chat {\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 320px);\n  min-height: 420px;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius);\n  background-color: var(--chat-surface);\n  overflow: hidden;\n}\n\n/* The shared chat body (transcript → banners → composer), used by the\n   team chat dock and the form-assist modal pane. Fills its container. */\n.chat-surface {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n\n.chat-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 12px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n/* Pencil + conversation picker/input sit together on the left */\n.chat-header-left {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  min-width: 0;\n  flex: 1;\n}\n\n.chat-header-title {\n  font-weight: 600;\n}\n\n.chat-new-conversation {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  font-size: 0.85rem;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  background: none;\n  color: var(--text-color);\n  cursor: pointer;\n}\n\n.chat-new-conversation:hover:not(:disabled) {\n  border-color: var(--button-primary-bg);\n  color: var(--button-primary-bg);\n}\n\n.chat-new-conversation:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.chat-connection-banner {\n  padding: 6px 12px;\n  font-size: 0.85rem;\n  text-align: center;\n  color: var(--warning-text);\n  background-color: var(--warning-bg);\n  border-bottom: 1px solid var(--warning-border);\n}\n\n.chat-error-banner {\n  padding: 8px 12px;\n  font-size: 0.9rem;\n  color: #b91c1c;\n  background-color: #fee2e2;\n  border-bottom: 1px solid #fca5a5;\n  cursor: pointer;\n}\n\n.composer-funds-notice {\n  padding: 6px 12px;\n  font-size: 0.85rem;\n  text-align: center;\n  color: var(--warning-text);\n  background-color: var(--warning-bg);\n  border-top: 1px solid var(--warning-border);\n}\n\n.composer-funds-notice a,\n.composer-funds-notice-cta {\n  color: inherit;\n  font-weight: 600;\n  text-decoration: underline;\n}\n\n/* The \"Add funds\" CTA is a button (opens a modal) but reads as a plain\n   themed link — strip the global button chrome, including the pill shape and\n   hover background (`button:hover` in App.css outranks a bare class). */\n.composer-funds-notice-cta,\n.composer-funds-notice-cta:hover {\n  background: none;\n  border: none;\n  border-radius: 0;\n  padding: 0;\n  margin: 0;\n  font: inherit;\n  cursor: pointer;\n}\n\n/* Out of funds / budget-paused: agents are actually stopped — use the\n   stronger Harbor Ledger danger palette. Low funds stays on the softer\n   warning palette. Both resolve per theme (light/dark) automatically. */\n.composer-funds-notice-no-funds,\n.composer-funds-notice-budget {\n  color: var(--danger-text);\n  background-color: var(--danger-bg);\n  border-top: 1px solid var(--danger-text);\n}\n\n.chat-message-list {\n  flex: 1;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.chat-empty-state {\n  margin: auto;\n  max-width: 420px;\n  text-align: center;\n  color: var(--secondary-text-color);\n}\n\n.chat-turn {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.chat-user-row {\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n/* Messages from other participants align to the left like agent replies */\n.chat-turn-other .chat-user-row {\n  justify-content: flex-start;\n}\n\n.chat-user-bubble {\n  max-width: 75%;\n  padding: 10px 14px;\n  border-radius: var(--radius) var(--radius) 2px var(--radius);\n  background-color: var(--accent-tint);\n  color: var(--accent-tint-text);\n}\n\n/* Another participant's message: neutral grey, left-tailed bubble */\n.chat-user-bubble-other {\n  border-radius: var(--radius) var(--radius) var(--radius) 2px;\n  background-color: var(--card-background);\n  color: var(--text-color);\n}\n\n.chat-user-text {\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n/* Dashed edges distinguish live voice text from the durable transcript that\n   replaces it; direction still follows the established chat bubble grammar. */\n.voice-provisional-timeline {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.voice-provisional-bubble {\n  box-sizing: border-box;\n  max-width: min(75%, 40rem);\n  padding: 9px 12px;\n  border: 1px dashed var(--border-strong);\n  overflow-wrap: anywhere;\n}\n\n.voice-provisional-bubble-input {\n  align-self: flex-end;\n  border-color: var(--link-color);\n  border-radius: var(--radius) var(--radius) 2px var(--radius);\n  background: var(--accent-tint);\n  color: var(--accent-tint-text);\n}\n\n.voice-provisional-bubble-output {\n  align-self: flex-start;\n  border-radius: var(--radius) var(--radius) var(--radius) 2px;\n  background: var(--surface-raised);\n  color: var(--text-color);\n}\n\n.voice-provisional-bubble span {\n  display: block;\n  font-family: var(--font-mono);\n  font-size: 0.64rem;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  opacity: 0.72;\n}\n\n.voice-provisional-bubble p {\n  margin: 4px 0 0;\n  line-height: 1.45;\n  white-space: pre-wrap;\n}\n\n@media (max-width: 640px) {\n  .voice-provisional-bubble {\n    max-width: 88%;\n  }\n}\n\n/* @mention of an agent in a user bubble, linking to its details page.\n   Inherits the bubble's text color so it stays legible on both the\n   accent-tinted own-message bubble and the neutral other-participant one. */\n.chat-mention {\n  color: inherit;\n  font-weight: 600;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.chat-mention:hover {\n  opacity: 0.85;\n}\n\n.chat-sending-badge {\n  font-size: 0.75rem;\n  color: var(--secondary-text-color);\n  white-space: nowrap;\n}\n\n/* Author label above another participant's bubble (multiplayer) */\n.chat-user-author {\n  align-self: flex-start;\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: var(--secondary-text-color, #6b7280);\n  margin-bottom: -4px;\n  padding-left: 4px;\n}\n\n/* Subtle centered hairline marking a compaction point */\n.chat-compacted-divider {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 6px 0;\n}\n\n.chat-compacted-divider::before,\n.chat-compacted-divider::after {\n  content: '';\n  flex: 1;\n  border-top: 1px solid var(--border-color, #d1d5db);\n  opacity: 0.6;\n}\n\n.chat-compacted-divider-text {\n  font-size: 0.72rem;\n  color: var(--secondary-text-color, #6b7280);\n  /* Wrap long system notes (e.g. monitor pings) instead of forcing the row\n     wider than the chat and causing horizontal scroll. min-width:0 lets this\n     flex child shrink below its content width so it can wrap. */\n  white-space: normal;\n  overflow-wrap: anywhere;\n  text-align: center;\n  min-width: 0;\n}\n\n/* A compaction marker is clickable: it opens the summary modal */\n.chat-compacted-divider-button {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.chat-compacted-divider-button:hover {\n  color: var(--primary-text-color, #111827);\n  text-decoration: underline;\n}\n\n/* The compaction summary shown in the divider's modal */\n.chat-compaction-summary {\n  overflow-y: auto;\n  min-height: 0;\n  font-size: 0.85rem;\n  line-height: 1.5;\n  color: var(--primary-text-color, #111827);\n}\n\n/* Transient /compact feedback above the composer (noop/failure cases) */\n.chat-compact-notice {\n  font-size: 0.78rem;\n  color: var(--secondary-text-color, #6b7280);\n  padding: 4px 12px;\n  text-align: center;\n  cursor: pointer;\n}\n\n/* Thinking region */\n.chat-thinking {\n  align-self: flex-start;\n  max-width: 85%;\n}\n\n.chat-thinking-live {\n  width: 85%;\n  border: 1px dashed var(--border-color);\n  border-radius: var(--radius);\n  padding: 8px 12px;\n  background-color: var(--card-background);\n}\n\n.chat-thinking-header {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.85rem;\n  color: var(--secondary-text-color);\n}\n\n.chat-thinking-icon {\n  animation: chat-pulse 1.6s ease-in-out infinite;\n}\n\n@keyframes chat-pulse {\n  0%,\n  100% {\n    opacity: 0.4;\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n/* Ordered thought text + tool pills, in stream order */\n.chat-thinking-segments {\n  margin-top: 6px;\n  max-height: 140px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.chat-thinking-content {\n  font-size: 0.8rem;\n  line-height: 1.4;\n  word-break: break-word;\n  color: var(--secondary-text-color);\n}\n\n.chat-thinking-content > :first-child {\n  margin-top: 0;\n}\n\n.chat-thinking-content > :last-child {\n  margin-bottom: 0;\n}\n\n.chat-thinking-content p {\n  margin: 0.35em 0;\n}\n\n.chat-thinking-content h1,\n.chat-thinking-content h2,\n.chat-thinking-content h3,\n.chat-thinking-content h4,\n.chat-thinking-content h5,\n.chat-thinking-content h6 {\n  font-size: 0.9rem;\n  margin: 0.65em 0 0.25em;\n}\n\n/* \"<action_summary>…\" — a live turn's one-line status (the\n   latest tool call's model-provided summary), shown under the collapsed\n   \"View thoughts\" toggle */\n.chat-thinking-status {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 6px;\n  font-size: 0.8rem;\n  font-style: italic;\n  color: var(--secondary-text-color);\n}\n\n.chat-thinking-status-text {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.chat-thinking-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  border: none;\n  background: none;\n  padding: 0;\n  font-size: 0.8rem;\n  color: var(--link-color);\n  cursor: pointer;\n}\n\n.chat-thinking-expanded {\n  margin-top: 6px;\n  max-height: 320px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  border-left: 3px solid var(--border-color);\n  padding: 6px 12px;\n  background-color: var(--card-background);\n  border-radius: 0 8px 8px 0;\n}\n\n/* A tool call's pill: clickable, opens the tool-call detail modal */\n.chat-tool-chip {\n  align-self: flex-start;\n  font-size: 0.72rem;\n  font-family: monospace;\n  padding: 2px 8px;\n  border-radius: 999px;\n  border: 1px solid var(--border-color);\n  color: var(--secondary-text-color);\n  background-color: var(--background-color);\n  cursor: pointer;\n  /* Button reset: chip looks the same as the old non-interactive span */\n  appearance: none;\n  line-height: 1.4;\n}\n\n/* :not(:disabled) bumps specificity above the app-wide `button:hover` rule,\n   which would otherwise repaint the chip with the primary button color */\n.chat-tool-chip:not(:disabled):hover {\n  background-color: var(--background-color);\n  border-color: var(--link-color);\n  color: var(--link-color);\n}\n\n.chat-tool-chip-started {\n  border-color: var(--button-primary-bg);\n  color: var(--button-primary-bg);\n}\n\n.chat-tool-chip-failed {\n  border-color: #dc2626;\n  color: #dc2626;\n}\n\n/* A reloaded turn's lazily-fetched tool calls: shown while the request for\n   the \"View thoughts\" panel's tool-call pills is in flight */\n.chat-thinking-history-loading {\n  font-size: 0.72rem;\n  color: var(--secondary-text-color);\n}\n\n/* Tool call detail modal (ToolCallModal) */\n/* The model's action_summary for the call, shown under the modal title */\n.tool-call-modal-summary {\n  margin: 0 0 10px;\n  font-size: 0.85rem;\n  font-style: italic;\n  color: var(--secondary-text-color);\n}\n\n/* Flags a call whose tool reported failure, so an errored call no longer\n   renders identically to a successful one. */\n.tool-call-modal-outcome {\n  margin: 0 0 10px;\n  padding: 6px 10px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--danger-text);\n  border: 1px solid var(--danger-text);\n  border-radius: 4px;\n}\n\n/* Response-time line (\"Took 1.2 s\"), under the summary */\n.tool-call-modal-duration {\n  margin: 0 0 10px;\n  font-size: 0.78rem;\n  color: var(--secondary-text-color);\n}\n\n/* Structured JSON tree (JsonView) inside a tool-call value box */\n.json-view {\n  font-family: var(--font-mono, monospace);\n  font-size: 0.8rem;\n  line-height: 1.45;\n}\n\n.json-view-row {\n  word-break: break-word;\n}\n\n.json-view-children {\n  padding-left: 18px;\n}\n\n.json-view-toggle {\n  border: none;\n  background: none;\n  padding: 0 4px 0 0;\n  cursor: pointer;\n  font-size: 0.7rem;\n  color: var(--secondary-text-color);\n}\n\n.json-view-key {\n  color: var(--link-color);\n}\n\n.json-view-punct,\n.json-view-collapsed-note {\n  color: var(--secondary-text-color);\n}\n\n.json-view-string {\n  color: var(--success-text);\n  white-space: pre-wrap;\n}\n\n.json-view-number {\n  color: var(--warning-text);\n}\n\n.json-view-boolean {\n  color: var(--danger-text);\n}\n\n.json-view-null {\n  color: var(--secondary-text-color);\n  font-style: italic;\n}\n\n.tool-call-modal-section-heading {\n  margin: 14px 0 4px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--text-color);\n}\n\n.tool-call-modal-section-heading:first-child {\n  margin-top: 0;\n}\n\n/* Heading row for an input/output pane: title left, copy control right. The\n   copy button sits here rather than inside the scroll pane so it stays put\n   while a long value scrolls under it. */\n.tool-call-modal-section {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  margin: 14px 0 4px;\n}\n\n.tool-call-modal-section:first-child {\n  margin-top: 0;\n}\n\n.tool-call-modal-section .tool-call-modal-section-heading {\n  margin: 0;\n}\n\n/* AsyncButton supplies the icon/label flex row and the disabled treatment;\n   this only dresses it down to a quiet secondary control. */\n.tool-call-copy {\n  padding: 3px 8px;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm, 6px);\n  background: transparent;\n  color: var(--secondary-text-color);\n  font-size: 0.72rem;\n  cursor: pointer;\n}\n\n.tool-call-copy:hover:not(:disabled) {\n  background: var(--surface-subtle, rgba(127, 127, 127, 0.08));\n  color: var(--text-color);\n}\n\n.tool-call-modal-pre {\n  margin: 0;\n  max-height: 240px;\n  overflow: auto;\n  padding: 10px;\n  white-space: pre-wrap;\n  word-break: break-word;\n  font-family: monospace;\n  font-size: 0.8rem;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm, 6px);\n  background-color: var(--card-background);\n  color: var(--text-color);\n}\n\n/* Agent response */\n.chat-agent-response {\n  align-self: flex-start;\n  max-width: 85%;\n  padding: 10px 14px;\n  border-radius: var(--radius) var(--radius) var(--radius) 2px;\n  background-color: var(--card-background);\n  color: var(--text-color);\n  word-break: break-word;\n}\n\n.chat-agent-response > *:first-child {\n  margin-top: 0;\n}\n\n.chat-agent-response > *:last-child {\n  margin-bottom: 0;\n}\n\n.chat-agent-response pre {\n  overflow-x: auto;\n  padding: 8px;\n  border-radius: var(--radius-sm);\n  background-color: rgba(0, 0, 0, 0.08);\n}\n\n.chat-agent-response code {\n  font-size: 0.85em;\n}\n\n.chat-agent-response table {\n  border-collapse: collapse;\n}\n\n.chat-agent-response th,\n.chat-agent-response td {\n  border: 1px solid var(--border-color);\n  padding: 4px 8px;\n}\n\n/* Lists, tables, code and quotes in rendered markdown come from the shared\n   `markdown-content` rules (markdown-content.css), which the chat bubble\n   carries alongside .chat-agent-response. */\n\n.chat-agent-response-streaming::after {\n  content: '▍';\n  animation: chat-pulse 1s ease-in-out infinite;\n}\n\n.chat-turn-error {\n  align-self: flex-start;\n  max-width: 85%;\n  padding: 8px 12px;\n  border-radius: var(--radius);\n  font-size: 0.9rem;\n  color: #b91c1c;\n  background-color: #fee2e2;\n  border: 1px solid #fca5a5;\n}\n\n/* A pause is expected/recoverable, not an error: muted amber, not red. */\n.chat-turn-paused {\n  align-self: flex-start;\n  max-width: 85%;\n  padding: 8px 12px;\n  border-radius: var(--radius);\n  font-size: 0.9rem;\n  color: #92400e;\n  background-color: #fef3c7;\n  border: 1px solid #fcd34d;\n}\n\n.chat-compacted-divider-text a,\n.chat-turn-error a,\n.chat-turn-paused a {\n  color: inherit;\n  font-weight: 600;\n  text-decoration: underline;\n}\n\n.chat-compacted-divider-text p,\n.chat-turn-error p,\n.chat-turn-paused p {\n  margin: 0;\n}\n\n/* Attachments */\n.chat-user-attachments {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-bottom: 6px;\n}\n\n.chat-user-attachment-chip {\n  font-size: 0.78rem;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background-color: rgba(255, 255, 255, 0.2);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 220px;\n}\n\n/* Image attachment: small clickable thumbnail (opens full size in a tab) */\n.chat-attachment-image {\n  display: inline-block;\n  line-height: 0;\n  border-radius: var(--radius);\n  overflow: hidden;\n  cursor: pointer;\n}\n.chat-attachment-image img {\n  max-width: 160px;\n  max-height: 160px;\n  object-fit: cover;\n  display: block;\n}\n\n/*\n * Images the agent generated are the point of the message, not an aside, so\n * they render large enough to actually judge — unlike the 160px thumbnails\n * used for what a person attached to their own question. Still clickable\n * through to full size, and object-fit is `contain` because cropping a\n * generated image hides the composition the person asked for.\n */\n.chat-agent-attachments {\n  margin-top: 10px;\n}\n.chat-agent-attachments .chat-attachment-image img {\n  max-width: min(420px, 100%);\n  max-height: 420px;\n  object-fit: contain;\n}\n\n/*\n * Generated audio plays in place. Full width of the bubble so the scrubber\n * is usable — a 160px player is a decoration, not a control.\n */\n.chat-attachment-audio {\n  width: 100%;\n  max-width: 420px;\n  height: 40px;\n  display: block;\n}\n\n/* Non-image file: a download chip with the file name */\n.chat-attachment-file {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.78rem;\n  padding: 4px 10px;\n  border-radius: var(--radius);\n  background-color: rgba(127, 127, 127, 0.15);\n  color: inherit;\n  text-decoration: none;\n  max-width: 240px;\n}\n.chat-attachment-file:hover {\n  background-color: rgba(127, 127, 127, 0.28);\n}\n.chat-attachment-file-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Small grey \"time ago\" beside a sender name / below own messages */\n.chat-sent-time {\n  font-family: var(--font-mono);\n  font-variant-numeric: tabular-nums;\n  font-size: 0.7rem;\n  font-weight: 400;\n  color: var(--secondary-text-color);\n}\n\n/* Discreet per-response LLM cost, beside the sent time */\n.chat-msg-cost {\n  font-size: 0.72rem;\n  font-weight: 400;\n  color: var(--secondary-text-color, #6b7280);\n  cursor: default;\n}\n\n/* Muted running conversation total at the end of the chat history */\n.chat-conversation-cost {\n  align-self: center;\n  max-width: 100%;\n  font-size: 0.72rem;\n  font-weight: 400;\n  color: var(--secondary-text-color, #6b7280);\n  text-align: center;\n  white-space: normal;\n  cursor: default;\n}\n\n/* Wiki-origin chip: links a highlight-to-chat conversation back to its page */\n.chat-wiki-origin-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  max-width: 160px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 0.72rem;\n  padding: 2px 8px;\n  margin-right: 8px;\n  border: 1px solid var(--border-color);\n  border-radius: 999px;\n  color: var(--secondary-text-color, #6b7280);\n  text-decoration: none;\n}\n\n.chat-wiki-origin-chip:hover {\n  color: var(--text-color);\n  background: color-mix(in srgb, var(--link-color) 8%, transparent);\n}\n.chat-user-time {\n  align-self: flex-end;\n  padding-right: 4px;\n}\n\n.chat-composer-container {\n  border-top: 1px solid var(--border-color);\n  background-color: var(--background-color);\n}\n\n.chat-attach-error {\n  padding: 6px 12px;\n  font-size: 0.85rem;\n  color: #b91c1c;\n  background-color: #fee2e2;\n  cursor: pointer;\n}\n\n.chat-attachment-previews {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 8px 12px 0;\n}\n\n.chat-attachment-preview {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border: 1px solid var(--border-color);\n  border-radius: 999px;\n  font-size: 0.8rem;\n  color: var(--text-color);\n  background-color: var(--card-background);\n  max-width: 280px;\n}\n\n.chat-attachment-preview-error {\n  border-color: #dc2626;\n  color: #dc2626;\n}\n\n.chat-attachment-name {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.chat-attachment-error-text {\n  font-size: 0.72rem;\n}\n\n.chat-attachment-spinner {\n  animation: chat-spin 1s linear infinite;\n}\n\n@keyframes chat-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.chat-attachment-remove {\n  display: flex;\n  border: none;\n  background: none;\n  padding: 2px;\n  color: inherit;\n  cursor: pointer;\n}\n\n.chat-composer-attach {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  /* Global button padding would squeeze the icon inside the fixed-size\n     button (same fix as .chat-composer-stop / .chat-dock-action) */\n  padding: 0;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius);\n  background: none;\n  color: var(--secondary-text-color);\n  cursor: pointer;\n}\n\n.chat-composer-attach svg {\n  width: 13.5px;\n  height: 13.5px;\n  flex-shrink: 0;\n}\n\n.chat-composer-attach:hover:not(:disabled) {\n  color: var(--button-primary-bg);\n  border-color: var(--button-primary-bg);\n}\n\n/* Composer */\n.chat-composer {\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n  padding: 12px;\n}\n\n.chat-composer-input {\n  flex: 1;\n  resize: none;\n  padding: 10px 12px;\n  font-size: 0.95rem;\n  font-family: inherit;\n  line-height: 1.4;\n  border: 1px solid var(--input-border);\n  border-radius: var(--radius);\n  background-color: var(--background-color);\n  color: var(--text-color);\n}\n\n.chat-composer-input:focus {\n  outline: none;\n  border-color: var(--button-primary-bg);\n}\n\n.chat-composer-send {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border: none;\n  border-radius: 999px;\n  background-color: var(--button-primary-bg);\n  color: var(--button-primary-text);\n  cursor: pointer;\n}\n\n.chat-composer-send:hover:not(:disabled) {\n  background-color: var(--button-primary-hover);\n}\n\n.chat-composer-send:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.chat-composer-voice {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: none;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  border: 1px solid var(--button-light-border);\n  border-radius: 999px;\n  background: var(--button-light-bg);\n  color: var(--button-light-text);\n  cursor: pointer;\n}\n\n.chat-composer-voice:hover:not(:disabled) {\n  border-color: var(--button-primary-bg);\n  background: var(--button-pill-hover-bg);\n}\n\n.chat-composer-voice:focus-visible {\n  outline: 2px solid var(--button-primary-bg);\n  outline-offset: 2px;\n}\n\n/* Pending indicator: shown from send until the first streamed token */\n.chat-pending {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 8px 0;\n  color: var(--text-secondary, #6b7280);\n}\n\n.chat-pending-dots {\n  display: inline-flex;\n  gap: 4px;\n}\n\n.chat-pending-dots span {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background-color: currentColor;\n  animation: chat-pending-bounce 1.2s infinite ease-in-out;\n}\n\n.chat-pending-dots span:nth-child(2) {\n  animation-delay: 0.15s;\n}\n\n.chat-pending-dots span:nth-child(3) {\n  animation-delay: 0.3s;\n}\n\n@keyframes chat-pending-bounce {\n  0%,\n  60%,\n  100% {\n    opacity: 0.35;\n    transform: translateY(0);\n  }\n  30% {\n    opacity: 1;\n    transform: translateY(-3px);\n  }\n}\n\n/* --- Unified team chat --- */\n\n.chat-agent-turn {\n  margin-top: 10px;\n}\n\n.chat-agent-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--secondary-text-color, #6b7280);\n  margin-bottom: 2px;\n}\n\n.chat-agent-label-name {\n  color: inherit;\n  text-decoration: none;\n}\n\na.chat-agent-label-name:hover {\n  color: var(--link-color);\n  text-decoration: underline;\n}\n\n.chat-agent-metadata {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin-top: 3px;\n  color: var(--secondary-text-color, #6b7280);\n}\n\n.chat-agent-label-trigger {\n  font-weight: 400;\n  opacity: 0.8;\n}\n\n.chat-history-picker {\n  position: relative;\n  min-width: 0;\n}\n\n/* Pencil to the left of the conversation picker: rename the chat */\n.chat-title-edit-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: none;\n  width: 20px;\n  height: 26px;\n  padding: 0;\n  border: none;\n  border-radius: var(--radius-sm);\n  background: transparent;\n  color: var(--secondary-text-color, #6b7280);\n  cursor: pointer;\n}\n/* Inline SVGs collapse to width:0 inside a fixed-size flex button; pin it */\n.chat-title-edit-button svg {\n  flex: none;\n  width: 12px;\n  height: 12px;\n}\n\n.chat-title-edit-button:hover {\n  background: rgba(128, 128, 128, 0.15);\n  color: var(--text-color);\n}\n\n/* Inline title editor replacing the picker while renaming */\n.chat-title-input {\n  flex: 1;\n  min-width: 0;\n  max-width: 240px;\n  padding: 4px 8px;\n  border: 1px solid var(--primary-color, #4a90d9);\n  border-radius: var(--radius-sm);\n  background: var(--background-color);\n  color: var(--text-color);\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.chat-history-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  max-width: 220px;\n  padding: 4px 8px;\n  border: none;\n  border-radius: var(--radius-sm);\n  background: transparent;\n  color: var(--text-color);\n  font-weight: 600;\n  font-size: 0.9rem;\n  cursor: pointer;\n}\n\n.chat-history-button:hover {\n  background: rgba(128, 128, 128, 0.15);\n}\n\n.chat-history-title {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.chat-history-options {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  z-index: 10;\n  min-width: 240px;\n  max-width: 320px;\n  max-height: 280px;\n  overflow-y: auto;\n  padding: 4px;\n  border: 1px solid var(--border-color, #d1d5db);\n  border-radius: var(--radius);\n  background: var(--background-color, #fff);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);\n}\n\n.chat-history-option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 6px 10px;\n  border: none;\n  border-radius: var(--radius-sm);\n  background: transparent;\n  color: var(--text-color);\n  font-size: 0.85rem;\n  text-align: left;\n  cursor: pointer;\n}\n\n.chat-history-option-main {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 1px;\n}\n\n.chat-history-option-title {\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.chat-history-option-time {\n  font-size: 0.7rem;\n  color: var(--secondary-text-color, #6b7280);\n}\n\n/* Per-conversation unread mention count in the history dropdown */\n.chat-history-unread {\n  flex: none;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 5px;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9px;\n  background: var(--danger-bg, #e5484d);\n  color: #fff;\n  font-size: 0.68rem;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.chat-history-option:hover {\n  background: rgba(128, 128, 128, 0.12);\n}\n\n.chat-history-option-active {\n  color: var(--primary-color, #4a90d9);\n  font-weight: 600;\n}\n\n.chat-history-empty {\n  display: block;\n  padding: 8px 10px;\n  font-size: 0.85rem;\n  color: var(--secondary-text-color, #6b7280);\n}\n\n.chat-composer {\n  position: relative;\n}\n\n.chat-mention-popup {\n  position: absolute;\n  bottom: calc(100% + 6px);\n  left: 48px;\n  z-index: 20;\n  min-width: 180px;\n  max-height: 200px;\n  overflow-y: auto;\n  padding: 4px;\n  border: 1px solid var(--border-color, #d1d5db);\n  border-radius: var(--radius);\n  background: var(--background-color, #fff);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.18);\n}\n\n.chat-mention-option {\n  display: block;\n  width: 100%;\n  padding: 6px 10px;\n  border: none;\n  border-radius: var(--radius-sm);\n  background: transparent;\n  color: var(--text-color);\n  font-size: 0.875rem;\n  text-align: left;\n  cursor: pointer;\n}\n\n.chat-mention-option:hover {\n  background: rgba(128, 128, 128, 0.12);\n}\n\n.chat-mention-option-active {\n  background: rgba(74, 144, 217, 0.15);\n  color: var(--primary-color, #4a90d9);\n  font-weight: 600;\n}\n\n/* Agents that can be mentioned only after being added (e.g. team agents\n   not on the project) — selectable, but visibly secondary */\n.chat-mention-option-unavailable {\n  color: var(--secondary-text-color);\n  opacity: 0.65;\n}\n\n.chat-approval-banner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin: 0 12px 8px;\n  padding: 8px 12px;\n  border: 1px solid rgba(224, 130, 6, 0.4);\n  border-radius: var(--radius);\n  background: rgba(224, 130, 6, 0.1);\n  color: var(--text-color);\n  font-size: 0.85rem;\n}\n\n.chat-approve-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 12px;\n  border: none;\n  border-radius: var(--radius-sm);\n  background: var(--button-primary-bg, #4a90d9);\n  color: var(--button-primary-text, #fff);\n  font-size: 0.85rem;\n  cursor: pointer;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.chat-composer-stop {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  border: none;\n  border-radius: var(--radius);\n  background-color: #e0245e;\n  color: #fff;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.chat-composer-stop:hover {\n  background-color: #c01e50;\n}\n\n.chat-composer-stop svg {\n  flex-shrink: 0;\n}\n\n/* ── Inline interactive prompts (seek_feedback / request_capability) ── */\n.chat-interaction {\n  margin: 8px 0 2px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.chat-interaction-options {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n.chat-interaction-option {\n  border: 1px solid var(--primary-color, #2563eb);\n  color: var(--primary-color, #2563eb);\n  background: transparent;\n  border-radius: 16px;\n  padding: 5px 12px;\n  font-size: 0.85rem;\n  cursor: pointer;\n}\n.chat-interaction-option:hover:not(:disabled) {\n  background: var(--primary-color, #2563eb);\n  color: #fff;\n}\n.chat-interaction-option:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n.chat-interaction-other {\n  display: flex;\n  gap: 6px;\n}\n/* App.css's global `form button { width: 100% }` would crush the input */\n.chat-interaction-other button {\n  width: auto;\n  flex: 0 0 auto;\n}\n.chat-interaction-other input {\n  flex: 1;\n  min-width: 0;\n  padding: 6px 10px;\n  border: 1px solid var(--input-border, #d1d5db);\n  border-radius: var(--radius);\n  background: var(--background-color, #fff);\n  color: var(--text-color, #111);\n}\n.chat-interaction-other button,\n.chat-interaction-grant,\n.chat-interaction-decline {\n  border: none;\n  border-radius: var(--radius);\n  padding: 6px 12px;\n  font-size: 0.85rem;\n  cursor: pointer;\n}\n.chat-interaction-other button,\n.chat-interaction-grant {\n  background: var(--button-primary-bg, #2563eb);\n  color: var(--button-primary-text, #fff);\n}\n.chat-interaction-decline {\n  background: var(--surface-hover-bg, #e5e7eb);\n  color: var(--text-color, #111);\n}\n.chat-interaction-other button:disabled,\n.chat-interaction-grant:disabled,\n.chat-interaction-decline:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n.chat-interaction-permission {\n  border: 1px solid var(--warning-border, #f0c36d);\n  background: var(--warning-bg, #fdf6e3);\n  color: var(--warning-text, #7a5b00);\n  border-radius: 10px;\n  padding: 10px 12px;\n}\n/* A decided request is no longer a call to action: drop the warning tint\n   and blend into the page, leaving a colored outcome line */\n.chat-interaction-permission-resolved {\n  border-color: var(--border-color, #e5e7eb);\n  background: var(--card-background, #f5f5f5);\n  color: var(--text-color, #111);\n}\n.chat-interaction-resolution {\n  font-size: 0.85rem;\n  font-weight: 600;\n  margin-top: 6px;\n}\n.chat-interaction-resolution.approved {\n  color: var(--success-text, #15803d);\n}\n.chat-interaction-resolution.declined {\n  color: var(--danger-text, #b91c1c);\n}\n.chat-interaction-permission-head {\n  font-size: 0.9rem;\n}\n/* Card next actions are a record of what the agent decided to do next, not a\n   request. Deliberately neutral: no warning tint, no buttons, nothing that\n   reads as waiting on a person. */\n.chat-interaction-next-action {\n  border: 1px solid var(--border-color, #e5e7eb);\n  background: var(--card-background, #f5f5f5);\n  color: var(--text-color, #111);\n  border-radius: 10px;\n  padding: 8px 12px;\n  gap: 2px;\n}\n.chat-interaction-next-action-head {\n  font-size: 0.8rem;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  opacity: 0.7;\n}\n.chat-interaction-next-action-body {\n  font-size: 0.85rem;\n}\n.chat-interaction-permission-desc {\n  font-size: 0.8rem;\n  opacity: 0.85;\n  margin-top: 4px;\n}\n.chat-interaction-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 8px;\n}\n/* Background monitor card: pending spinner + cancel, terminal badge */\n.chat-interaction-monitor {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  border: 1px solid var(--border-color, #e5e7eb);\n  background: var(--card-background, #f5f5f5);\n  color: var(--text-color, #111);\n  border-radius: 10px;\n  padding: 8px 12px;\n  font-size: 0.85rem;\n}\n/* Pending card is a grid so Cancel sits top-right beside the status line on\n   wide screens, and drops below the progress + centers on phones. Base stays\n   flex (above) for the terminal badge variant. */\n.chat-interaction-monitor-pending {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  grid-template-areas:\n    'status cancel'\n    'progress progress'\n    'error error';\n  align-items: center;\n  gap: 8px 12px;\n}\n.chat-interaction-monitor-pending .chat-interaction-monitor-row {\n  grid-area: status;\n}\n.chat-interaction-monitor-pending .chat-interaction-monitor-progress {\n  grid-area: progress;\n}\n.chat-interaction-monitor-pending .chat-interaction-monitor-cancel {\n  grid-area: cancel;\n  justify-self: end;\n}\n.chat-interaction-monitor-pending .chat-interaction-error {\n  grid-area: error;\n}\n@media (max-width: 768px) {\n  .chat-interaction-monitor-pending {\n    grid-template-columns: 1fr;\n    grid-template-areas:\n      'status'\n      'progress'\n      'cancel'\n      'error';\n  }\n  .chat-interaction-monitor-pending .chat-interaction-monitor-cancel {\n    justify-self: center;\n  }\n}\n.chat-interaction-monitor-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n/* Script-reported progress (MONITOR_STATUS / MONITOR_PROGRESS markers).\n   The bar flexes and the label wraps below it on narrow (mobile) widths\n   instead of squeezing into a skinny column beside the bar. */\n.chat-interaction-monitor-progress {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px 10px;\n}\n.chat-interaction-monitor-progressbar {\n  flex: 1 1 140px;\n  max-width: 260px;\n  height: 8px;\n  border-radius: 4px;\n  background: var(--border-color, #e5e7eb);\n  overflow: hidden;\n}\n.chat-interaction-monitor-progressbar-fill {\n  height: 100%;\n  border-radius: 4px;\n  background: var(--accent-color, #2563eb);\n  transition: width 0.6s ease;\n}\n.chat-interaction-monitor-progress-label {\n  font-size: 0.8rem;\n  opacity: 0.85;\n  overflow-wrap: anywhere;\n}\n.chat-interaction-monitor-spinner {\n  width: 14px;\n  height: 14px;\n  flex: 0 0 auto;\n  border: 2px solid var(--border-color, #e5e7eb);\n  border-top-color: var(--accent-color, #2563eb);\n  border-radius: 50%;\n  animation: chat-monitor-spin 0.9s linear infinite;\n}\n@keyframes chat-monitor-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n.chat-interaction-monitor-text {\n  /* Shrinkable with a modest basis so the spinner keeps the text company on\n     the first line even at phone widths (basis auto would push the whole\n     text block onto its own row, stranding the spinner). */\n  flex: 1 1 200px;\n  min-width: 0;\n}\n.chat-interaction-monitor-cancel {\n  flex: 0 0 auto;\n}\n.chat-interaction-monitor-badge {\n  font-weight: 600;\n}\n.chat-interaction-monitor-done .chat-interaction-monitor-badge {\n  color: var(--success-text, #15803d);\n}\n.chat-interaction-monitor-timeout .chat-interaction-monitor-badge,\n.chat-interaction-monitor-error .chat-interaction-monitor-badge {\n  color: var(--danger-text, #b91c1c);\n}\n.chat-interaction-monitor-canceled .chat-interaction-monitor-badge {\n  color: var(--text-muted, #6b7280);\n}\n\n/* Agent-authored \"how to obtain this credential\" walkthrough (markdown) */\n.chat-interaction-instructions {\n  font-size: 0.82rem;\n  line-height: 1.5;\n  background: var(--background-color, #fff);\n  border: 1px solid var(--border-color, #e5e7eb);\n  border-radius: var(--radius);\n  padding: 10px 12px;\n  margin: 8px 0 12px;\n  max-height: 260px;\n  overflow-y: auto;\n}\n.chat-interaction-instructions p,\n.chat-interaction-instructions ol,\n.chat-interaction-instructions ul {\n  margin: 0 0 6px;\n  padding-left: 18px;\n}\n.chat-interaction-instructions p {\n  padding-left: 0;\n}\n.chat-interaction-instructions :last-child {\n  margin-bottom: 0;\n}\n.chat-interaction-error {\n  color: var(--warning-text, #7a5b00);\n  font-size: 0.8rem;\n}\n\n/* Grant params modal */\n.interaction-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n.interaction-modal {\n  background: var(--card-background, #fff);\n  color: var(--text-color, #111);\n  border-radius: var(--radius);\n  padding: 20px;\n  width: min(440px, 92vw);\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n}\n.interaction-modal h3 {\n  margin: 0 0 6px;\n}\n.interaction-modal-sub {\n  font-size: 0.82rem;\n  color: var(--secondary-text-color, #6b7280);\n  margin: 0 0 14px;\n}\n.interaction-modal-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 12px;\n  font-size: 0.82rem;\n}\n.interaction-modal-field input {\n  padding: 8px 10px;\n  border: 1px solid var(--input-border, #d1d5db);\n  border-radius: var(--radius);\n  background: var(--background-color, #fff);\n  color: var(--text-color, #111);\n}\n.interaction-modal-error {\n  color: var(--warning-text, #b45309);\n  font-size: 0.8rem;\n  margin-bottom: 10px;\n}\n.interaction-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n.interaction-modal-actions button {\n  border: none;\n  border-radius: var(--radius);\n  padding: 8px 14px;\n  cursor: pointer;\n  background: var(--surface-hover-bg, #e5e7eb);\n  color: var(--text-color, #111);\n}\n.interaction-modal-actions .interaction-modal-save {\n  background: var(--button-primary-bg, #2563eb);\n  color: var(--button-primary-text, #fff);\n}\n.chat-interaction-decision-note {\n  display: grid;\n  gap: 5px;\n  margin: 10px 0;\n  font-size: 0.78rem;\n  color: var(--text-muted, #6b7280);\n}\n.chat-interaction-decision-note textarea,\n.interaction-modal-field textarea {\n  min-height: 58px;\n  resize: vertical;\n  border: 1px solid var(--border-color, #ccc);\n  border-radius: 7px;\n  padding: 8px;\n  color: inherit;\n  background: var(--input-bg, transparent);\n}\n.chat-approval-inline {\n  margin: 12px 0;\n}\n/* The work-stream pointer. It used to float in the gap between the composer\n   and the transcript, which read as chrome bolted onto the input; it is a\n   standing fact about the conversation, so it now sits at the END of the\n   transcript and scrolls with it. Same bare treatment as .chat-notice above —\n   no border, no fill, nobody said it — but a full-width row rather than\n   centered, because the run's status is a second column, not a trailing\n   clause. */\n.chat-work-stream-link {\n  align-items: center;\n  align-self: stretch;\n  display: flex;\n  gap: 12px;\n  justify-content: space-between;\n  margin-top: -6px;\n}\n\n.chat-work-stream-link a {\n  color: var(--link-color, #2563eb);\n  font-size: 0.82rem;\n}\n\n.chat-work-stream-link span {\n  color: var(--secondary-text-color);\n  flex: none;\n  font-size: 0.72rem;\n  text-transform: capitalize;\n}\n\n/* Deferred wait card. Same anatomy as the monitor card above — pending\n   spinner with a Cancel, terminal badge — because they are the same thing to\n   a reader: the agent is asleep and will come back. */\n.chat-interaction-wait {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  border: 1px solid var(--border-color, #e5e7eb);\n  background: var(--card-background, #f5f5f5);\n  color: var(--text-color, #111);\n  border-radius: 10px;\n  padding: 8px 12px;\n  font-size: 0.85rem;\n}\n.chat-interaction-wait-pending {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  grid-template-areas:\n    'status cancel'\n    'progress progress'\n    'error error';\n  align-items: center;\n  gap: 8px 12px;\n}\n.chat-interaction-wait-pending .chat-interaction-wait-row {\n  grid-area: status;\n}\n.chat-interaction-wait-pending .chat-interaction-wait-progress {\n  grid-area: progress;\n}\n.chat-interaction-wait-pending .chat-interaction-wait-cancel {\n  grid-area: cancel;\n  justify-self: end;\n  width: auto;\n  margin-top: 0;\n}\n.chat-interaction-wait-pending .chat-interaction-error {\n  grid-area: error;\n}\n.chat-interaction-wait-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.chat-interaction-wait-spinner {\n  width: 12px;\n  height: 12px;\n  flex: 0 0 auto;\n  border: 2px solid var(--border-color, #d1d5db);\n  border-top-color: var(--primary-color, #2563eb);\n  border-radius: 50%;\n  animation: chat-monitor-spin 0.9s linear infinite;\n}\n.chat-interaction-wait-progress {\n  color: var(--secondary-text-color, #6b7280);\n  font-size: 0.8rem;\n}\n.chat-interaction-wait-badge {\n  font-weight: 600;\n}\n.chat-interaction-wait-reason {\n  color: var(--secondary-text-color, #6b7280);\n}\n/* Max time reached is not an error state: nothing broke, the clock ran out,\n   and the agent has already been woken to decide what to do. */\n.chat-interaction-wait-failed .chat-interaction-wait-badge {\n  color: var(--danger-color, #b91c1c);\n}\n@media (max-width: 640px) {\n  .chat-interaction-wait-pending {\n    grid-template-columns: 1fr;\n    grid-template-areas:\n      'status'\n      'progress'\n      'cancel'\n      'error';\n  }\n  .chat-interaction-wait-pending .chat-interaction-wait-cancel {\n    justify-self: stretch;\n  }\n}\n\n/* Form-assist hand-off notice: the form was submitted and the record now\n   exists. Nobody's utterance, so it gets no bubble chrome at all — a bordered,\n   tinted pill read as just another message from someone. Bare text on the\n   transcript background is the whole treatment. */\n.chat-notice {\n  align-self: center;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  max-width: 92%;\n  margin: 6px 0;\n  color: var(--secondary-text-color);\n  font-size: 0.78rem;\n  text-align: left;\n  overflow-wrap: anywhere;\n}\n\n.chat-voice-lifecycle {\n  flex-direction: column;\n  justify-content: center;\n  gap: 2px;\n  text-align: center;\n}\n\n.chat-voice-lifecycle-cost {\n  font-family: var(--font-mono);\n  font-size: 0.7rem;\n  font-variant-numeric: tabular-nums;\n}\n\n.chat-artifact-notice {\n  align-items: stretch;\n  flex-direction: column;\n  width: min(720px, 92%);\n}\n\n.chat-artifact-notice video {\n  display: block;\n  width: 100%;\n  max-height: 420px;\n  border-radius: var(--radius-sm);\n  background: #000;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
